import { DYNAMIC_INPUT_KEY, ModuleInputKeyEnum } from '../constants';
import { ModuleIOValueTypeEnum } from '../constants';
import { FlowNodeInputTypeEnum } from '../node/constants';
import { FlowNodeInputItemType } from '../node/types';

export const Input_Template_Switch: FlowNodeInputItemType = {
  key: ModuleInputKeyEnum.switch,
  type: FlowNodeInputTypeEnum.target,
  label: '触发器',
  description:
    '大部分时候，你不需要连接该属性。\n当你需要延迟执行，或精确控制执行时机时，可以连接该属性。',
  valueType: ModuleIOValueTypeEnum.any,
  showTargetInApp: true,
  showTargetInPlugin: true,
};

export const Input_Template_History: FlowNodeInputItemType = {
  key: ModuleInputKeyEnum.chatHistory,
  type: FlowNodeInputTypeEnum.target,
  label: '聊天记录',
  required: false,
  valueType: ModuleIOValueTypeEnum.chatHistory,
  showTargetInApp: true,
  showTargetInPlugin: true,
};

export const Input_Template_UserChatInput: FlowNodeInputItemType = {
  key: ModuleInputKeyEnum.userChatInput,
  type: FlowNodeInputTypeEnum.target,
  label: '用户问题',
  required: true,
  valueType: ModuleIOValueTypeEnum.string,
  showTargetInApp: true,
  showTargetInPlugin: true,
};

export const Input_Template_AddInputParam: FlowNodeInputItemType = {
  key: ModuleInputKeyEnum.addInputParam,
  type: FlowNodeInputTypeEnum.addInputParam,
  valueType: ModuleIOValueTypeEnum.any,
  label: '',
  required: false,
  showTargetInApp: false,
  showTargetInPlugin: false,
};

export const Input_Template_DynamicInput: FlowNodeInputItemType = {
  key: DYNAMIC_INPUT_KEY,
  type: FlowNodeInputTypeEnum.target,
  valueType: ModuleIOValueTypeEnum.any,
  label: 'core.module.inputType.dynamicTargetInput',
  description: 'core.module.input.description.dynamic input',
  required: false,
  showTargetInApp: false,
  showTargetInPlugin: true,
  hideInApp: true,
};

export const Input_Template_Dataset_Quote: FlowNodeInputItemType = {
  key: ModuleInputKeyEnum.knowledges,
  type: FlowNodeInputTypeEnum.target,
  label: '知识库引用',
  description: 'core.module.Dataset quote.Input description',
  valueType: ModuleIOValueTypeEnum.datasetQuote,
};

export const Input_Template_System_Prompt: FlowNodeInputItemType = {
  key: ModuleInputKeyEnum.aiSystemPrompt,
  type: FlowNodeInputTypeEnum.textarea,
  max: 3000,
  valueType: ModuleIOValueTypeEnum.string,
  label: '提示词',
  description:
    '模型固定的引导词，通过调整该内容，可以引导模型聊天方向。该内容会被固定在上下文的开头。可使用变量，例如 {{language}}',
  placeholder:
    '模型固定的引导词，通过调整该内容，可以引导模型聊天方向。该内容会被固定在上下文的开头。可使用变量，例如 {{language}}',
  showTargetInApp: true,
  showTargetInPlugin: true,
};

export const Input_Template_AiModel: FlowNodeInputItemType = {
  key: ModuleInputKeyEnum.aiModel,
  type: FlowNodeInputTypeEnum.selectAiModel,
  label: '大语言模型',
  required: true,
  valueType: ModuleIOValueTypeEnum.string,
  showTargetInApp: false,
  showTargetInPlugin: false,
  value: 'gpt4',
  list: [
    { label: 'gpt3.5', value: 'gpt3.5' },
    { label: 'gpt4', value: 'gpt4' },
    { label: 'claude3', value: 'claude3' },
    { label: 'qwen', value: 'qwen' },
  ],
};
